"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsLoading = selectIsLoading;
exports.selectHasActiveSubscription = selectHasActiveSubscription;
exports.selectHasActiveLegacySubscription = selectHasActiveLegacySubscription;
exports.selectIsEpicLogin = selectIsEpicLogin;
exports.selectHasUnrealLicense = selectHasUnrealLicense;
exports.selectHasUnrealUnlimitedSubscription = selectHasUnrealUnlimitedSubscription;
exports.getEpicLinkEmail = getEpicLinkEmail;
exports.getQuixelEmail = getQuixelEmail;
exports.shouldShowSwitchAndRefundBanner = shouldShowSwitchAndRefundBanner;
exports.shouldUpdateEULA = shouldUpdateEULA;
exports.isStudioOrCustomPlan = isStudioOrCustomPlan;
exports.isMixerEulaAccepted = isMixerEulaAccepted;
exports.getEpicToken = getEpicToken;

var _utils = require("./utils");

function selectIsLoading(state) {
  var user = state.user;


  return !user.loaded;
}

function selectHasActiveSubscription(state) {
  var user = state.user;
  var subscription = user.subscription;


  var isActive = subscription && subscription.isActive;
  var lastPaidAt = subscription && subscription.lastPaidAt;

  try {
    var valid = isActive;

    return valid;
  } catch (e) {
    return false;
  }
}

function selectHasActiveLegacySubscription(state) {
  var user = state.user,
      subscriptions = state.subscriptions;
  var subscription = user.subscription;
  var plans = subscriptions.plansDecorated;


  var isActive = subscription && subscription.isActive;
  var switchingAllowed = subscription && (0, _utils.isSwitchingAllowed)(subscription.planId);

  var isLegacy = isActive && switchingAllowed;
  return isLegacy;
}

function selectIsEpicLogin(state) {
  var user = state.user;


  return !!user.epicAccountId;
}

function selectHasUnrealLicense(state) {
  var user = state.user;


  return !!user.isUnrealEULAAccepted;
}

function selectHasUnrealUnlimitedSubscription(state) {
  var user = state.user;
  var subscription = user.subscription;


  var isActive = subscription && subscription.isActive;
  var isUnrealUnlimited = subscription && subscription.planId === "unreal-unlimited";

  return isActive && isUnrealUnlimited;
}

function getEpicLinkEmail(state) {
  var auth = state.auth;
  var epicLogin = auth.epicLogin;


  return epicLogin.email;
}

function getQuixelEmail(state) {
  var auth = state.auth;
  var user = auth.user,
      epicLogin = auth.epicLogin;


  if (user && user.email) {
    return user.email;
  }

  return undefined;
}

function shouldShowSwitchAndRefundBanner(state) {
  var user = state.user;
  var isShowSwitchAndRefundBanner = user.isShowSwitchAndRefundBanner,
      subscription = user.subscription;

  var educationPlans = ["education-4K-quarterly", "education-4K-biannual", "education-4K-annual"];

  var education = subscription && educationPlans.find(function (p) {
    return p === subscription.planId;
  });
  var notEducation = !education;

  return isShowSwitchAndRefundBanner && notEducation;
}

function shouldUpdateEULA(state) {
  var updateVersion = state.auth.eula.updateVersion;


  return !!updateVersion;
}
function isStudioOrCustomPlan(state) {
  var subscription = state.user.subscription;


  if (subscription) {
    var planId = subscription.planId,
        doesGetCharged = subscription.doesGetCharged,
        isActive = subscription.isActive;

    var _isStudioOrCustomPlan = planId !== "unreal-unlimited" && doesGetCharged === false && isActive;

    return _isStudioOrCustomPlan;
  }

  return false;
}

function isMixerEulaAccepted(state) {
  var auth = state.auth;
  var mixerEula = auth.mixerEula;


  return mixerEula == true;
}

function getEpicToken(state) {
  var epicLogin = state.auth.epicLogin;
  var epicToken = epicLogin.epicToken;

  return epicToken;
}


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/selectors.js
// module id = 224
// module chunks = 0